import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function DropDown({ children }) {
  // Mobile Toggle
  const [mobileToggle, setMobileToggle] = useState(false);
  const { pathname } = useLocation();
  const handelMobileToggle = () => {
    setMobileToggle(!mobileToggle);
  };

  useEffect(() => {
    setMobileToggle(false);
  }, [pathname]);

  return (
    <>
      <span
        className={
          mobileToggle
            ? 'cs_munu_dropdown_toggle active'
            : 'cs_munu_dropdown_toggle'
        }
        onClick={handelMobileToggle}
      >
        <span></span>
      </span>
      {children}
    </>
  );
}
